// NO CHILL MERCH — tiny visual polish only. No Shopify backend/cart logic changed.
(() => {
  document.documentElement.classList.add('no-chill-ui');

  const header = document.querySelector('.shopify-section-group-header-group');
  if (header) {
    const updateHeader = () => {
      header.classList.toggle('nc-scrolled', window.scrollY > 18);
    };

    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.querySelectorAll('[data-ugc-marquee]').forEach((marquee) => {
    const track = marquee.querySelector('.ugc-track');
    if (!track) return;

    const pause = () => marquee.classList.add('is-paused');
    const play = () => marquee.classList.remove('is-paused');

    marquee.addEventListener('touchstart', pause, { passive: true });
    marquee.addEventListener('touchend', play, { passive: true });
    marquee.addEventListener('touchcancel', play, { passive: true });
  });
})();
